// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__phbqL","label":"styles_label__n8nrL"};